var BrandArray = new Array("1|HTP America",
"2|AHP",
"3|American Forge and Foundry",
"4|ATD",
"5|Auto Arc",
"6|Ben Pearson",
"7|Blue Point",
"8|Cebora",
"9|Century",
"10|Chicago Electric",
"11|Clarke",
"12|Craftsman",
"13|Dan MIG",
"14|Dayton",
"15|Daytona",
"16|Eastwood",
"17|ESAB",
"18|Everlast",
"19|Firepower",
"20|Forney",
"21|Henning Hanson",
"22|Hobart",
"23|LINCOLN",
"24|Longevity",
"25|LOTOS",
"26|L-TEC",
"27|MAC Tools",
"28|Marquette",
"29|MATCO",
"30|Miller",
"31|NAPA",
"32|PowerMate",
"33|Pro Spot",
"34|Schumacher Electric",
"35|SD Lee",
"36|Silver Beauty",
"37|SIP",
"38|Snap-On",
"39|Solar",
"40|Systematics",
"41|Thermal Arc",
"42|Titanium",
"43|Tweco",
"44|Vulcan",
"45|Weldmart");//MIG Welder Models

var ModelArray1 = new Array("1|Pro Pulse 220 MTS 15 Series MIG Gun",
"2|Pro Pulse 220 MTS 24 Series MIG Gun",
"3|Pro Pulse 220 MTS 26 Series MIG Gun",
"4|Pro Pulse 300 24 Series MIG Gun",
"5|Pro Pulse 300 26 Series MIG Gun",
"6|Pro Pulse 300 36 Series MIG Gun",
"7|Pro Pulse 300 501 Water-Cooled Gun Aluminum",                             
"8|Pro Pulse 300 501 Water-Cooled Gun Steel",  
"9|MTS 210 15 Series MIG Gun", 
"10|MTS 210 24 Series MIG Gun", 
"11|MTS 210 26 Series MIG Gun",
"12|MIG 200i",
"13|MIG 130",
"14|15 Series",
"15|24 Series",
"16|25 Series",
"17|26 Series",
"18|36 Series",
"19|Auto MIG",
"20|Econo MIG",
"21|Maxi MIG",
"22|Micro MIG",
"23|MIG 110",
"24|MIG 120",
"25|MIG 140",
"26|MIG 160",
"27|MIG 1600",
"28|MIG 160DV",
"29|MIG 200",
"30|MIG 240",
"31|MIG 240 Flex",
"32|MIG 2400",
"33|MIG 2400 Flex",
"34|MIG 2400-24-ST",
"35|MIG 2400-24-ST Flex",
"36|Mini MIG",
"37|MTS 160", 
"38|Pro MIG 100",               
"39|Pro Pulse 200 15 Series MIG Gun",
"40|Pro Pulse 200 24 Series MIG Gun",
"41|Pro Pulse 200 26 Series MIG Gun",                         
"42|Versa MIG");//HTP Models - MIG

var ModelArray2 = new Array("1|Alpha MIG 250 HTP Flex",
"2|Alpha MIG 250 HTP Replacement",
"3|Alpha MIG 250 OEM");//AHP Models - MIG

var ModelArray3 = new Array("1|MIG 140 HTP Replacement",
"2|MIG 160 HTP Replacement",
"3|MIG 180 HTP Replacement",
"4|Mitey MIG 101 HTP Replacement Model 1",
"5|Mitey MIG 101 HTP Replacement Model 2");//American Forge and Foundry Models - MIG

var ModelArray4 = new Array("1|37001 HTP Replacement Model 1",
"2|37001 HTP Replacement Model 2",
"3|37155 HTP Replacement");//ATD Models - MIG

var ModelArray5 = new Array("1|70 HTP Flex",
"2|70 HTP Replacement",
"3|90 HTP Flex",
"4|90 HTP Replacement",
"5|120 HTP Flex",
"6|120 HTP Replacement",
"7|140 HTP Flex",
"8|140 HTP Replacement",
"9|160 HTP Flex",
"10|160 HTP Replacement",
"11|175 HTP Flex",
"12|175 HTP Replacement",
"13|190 HTP Flex",
"14|190 HTP Replacement",
"15|190 OEM",
"16|255 HTP Flex",
"17|255 HTP Replacement",
"18|255 OEM",
"19|Benchmark HTP Flex",
"20|Benchmark HTP Replacement",
"21|Benchmark Pro HTP Flex",
"22|Benchmark Pro HTP Replacement",
"23|MW4110 HTP Flex",
"24|MW4110 HTP Replacement",
"25|MW4230 HTP Flex",
"26|MW4230 HTP Replacement",
"27|XLT 135 HTP Flex",
"28|XLT 135 HTP Replacement",
"29|XLT 135 OEM",
"30|XLT 142 HTP Flex",
"31|XLT 142 HTP Replacement",
"32|XLT 142 OEM",
"33|XLT 165 HTP Flex",
"34|XLT 165 HTP Replacement",
"35|XLT 165 OEM",
"36|XLT 182 HTP Flex",
"37|XLT 182 HTP replacement",
"38|XLT 182 OEM",
"39|XLT 185 HTP Flex",
"40|XLT 185 HTP Replacement",
"41|XLT 185 OEM",
"42|XLT 222 HTP Flex",
"43|XLT 222 HTP Replacement",
"44|XLT 222 OEM",
"45|XLT 270 HTP Flex",
"46|XLT 270 HTP Replacement",
"47|XLT 270 OEM");//Auto Arc Models - MIG

var ModelArray6 = new Array("1|MIG Combi HTP Replacement",
"2|Mini MIG HTP Replacement",
"3|Power Pro 160 HTP Replacement",
"4|Super Pro HTP Replacement");//Ben Pearson Models - MIG

var ModelArray7 = new Array("1|MB-120A HTP Replacement Model 1",
"2|MB-120A HTP Replacement Model 2",
"3|MB-135 HTP Replacement");//Blue Point Models - MIG

var ModelArray8 = new Array("1|Sound MIG 2035-MD HTP Replacement");//Cebora Models - MIG

var ModelArray9 = new Array("1|117-001 HTP Replacement",
"2|117-002 HTP Replacement",
"3|117-003 HTP Replacement",
"4|117-004 HTP Replacement",
"5|117-005 HTP Replacement",
"6|117-006 HTP Replacement",
"7|117-088 HTP Replacement",
"8|83071 117-071 HTP Flex",
"9|83071 117-071 HTP Replacement",
"10|83071 117-071 OEM",
"11|83075 117-034 HTP Flex",
"12|83075 117-034 HTP Replacement",
"13|83075 117-034 OEM",
"14|83085 117-050 HTP Flex",
"15|83085 117-050 HTP Replacement",
"16|83085 117-050 OEM",
"17|83090 117-070 HTP Flex",
"18|83090 117-070 HTP Replacement",
"19|83090 117-070 OEM",
"20|83101 117-064 HTP Flex",
"21|83101 117-064 HTP Replacement",
"22|83101 117-064 OEM",
"23|83105 117-052 HTP Flex",
"24|83105 117-052 HTP Replacement",
"25|83105 117-052 OEM",
"26|83110 117-051 HTP Flex",
"27|83110 117-051 HTP Replacement",
"28|83110 117-051 OEM",
"29|83111 117-051 HTP Flex",
"30|83111 117-051 HTP Replacement",
"31|83111 117-051 OEM",
"32|83125 117-076-000 HTP Replacement Model 1",
"33|83125 117-076-000 HTP Replacement Model 2",
"34|83126 117-076-100 HTP Replacement Model 1",
"35|83126 117-076-100 HTP Replacement Model 2",
"36|83130 117-065 HTP Flex",
"37|83130 117-065 HTP Replacement",
"38|83130 117-065 OEM",
"39|83131 117-066 HTP Flex",
"40|83131 117-066 HTP Replacement",
"41|83131 117-066 OEM",
"42|83133 117-067 HTP Flex",
"43|83133 117-067 HTP Replacement",
"44|83133 117-067 OEM",
"45|83136 117-077-100 HTP Replacement Model 1",
"46|83136 117-077-100 HTP Replacement Model 2",
"47|83137 117-077-000 HTP Replacement Model 1",
"48|83137 117-077-000 HTP Replacement Model 2",
"49|83140 117-087 HTP Replacment",
"50|83145 117-069 HTP Flex",
"51|83145 117-069 HTP Replacement",
"52|83145 117-069 OEM",
"53|83155 117-078-000 HTP Replacement Model 1",
"54|83155 117-078-000 HTP Replacement Model 2",
"55|83156 117-078-100 HTP Replacement Model 1",
"56|83156 117-078-100 HTP Replacement Model 2",
"57|83160 117-037 HTP Replacement",
"58|83160 117-037 OEM",
"59|83170 117-079-000 HTP Replacement Model 1",
"60|83170 117-079-000 HTP Replacement Model 2",
"61|83171 117-079-100 HTP Replacement Model 1",
"62|83171 117-079-100 HTP Replacement Model 2",
"63|83225 117-042 HTP Replacement",
"64|83225 117-042 OEM",
"65|83226 117-046 HTP Replacement",
"66|83226 117-046 OEM",
"67|All Star 117-002 HTP Replacement",
"68|All Star 117-015 HTP Flex",
"69|All Star 117-015 HTP Replacement",
"70|All Star 117-015 OEM",
"71|Portable MIG 117-008 HTP Flex",
"72|Portable MIG 117-008 HTP Replacement",
"73|Portable MIG 117-008 OEM",
"74|Quick Fix HTP Flex",
"75|Quick Fix HTP Replacement",
"76|Quick Fix OEM",
"77|Super Star HTP Replacement",
"78|Super Star OEM");//Century Models - MIG

var ModelArray10 = new Array("1|06068 HTP Replacement Model 1",
"2|06068 HTP Replacement Model 2",
"3|06271 HTP Replacement Model 1",
"4|06271 HTP Replacement Model 2",
"5|36691 HTP Replacement Model 1",
"6|36691 HTP Replacement Model 2",
"7|36693 HTP Replacement Model 1",
"8|36693 HTP Replacement Model 2",
"9|40092 HTP Replacement Model 1",
"10|40092 HTP Replacement Model 2",
"11|44567 HTP Replacement Model 1",
"12|44567 HTP Replacement Model 2",
"13|63582 HTP Replacement",
"14|68885 HTP Replacement Model 1",
"15|68885 HTP Replacement Model 2",
"16|68886 HTP Replacement Model 1",
"17|68886 HTP Replacement Model 2",
"18|93793 HTP Replacement Model 1",
"19|93793 HTP Replacement Model 2",
"20|94164 HTP Replacement Model 1",
"21|94164 HTP Replacement Model 2",
"22|97503 HTP Replacement Model 1",
"23|97503 HTP Replacement Model 2",
"24|98871 HTP Replacement Model 1",
"25|98871 HTP Replacement Model 2",
"26|Dual MIG 151 HTP Replacement",
"27|Dual MIG 151T HTP Replacement",
"28|Dual MIG 200 98304 HTP Replacement");//Chicago Electric Models - MIG

var ModelArray11 = new Array("1|100SG WE6440 HTP Replacement Model 1",
"2|100SG WE6440 HTP Replacement Model 2",
"3|Fluxcore 95 WE6480A HTP Replacement Model 1",
"4|Fluxcore 95 WE6480A HTP Replacement Model 2",
"5|MIG 100E MK2 HTP Replacement Model 1",
"6|MIG 100E MK2 HTP Replacement Model 2",
"7|MIG 100EN HTP Replacement",
"8|MIG 125EN WE6526 HTP Replacement",
"9|MIG 125EN WE6526 OEM",
"10|MIG 130E MK2 WE6510 HTP Replacement Model 1",
"11|MIG 130E MK2 WE6510 HTP Replacement Model 2",
"12|MIG 130EN WE6523 HTP Replacement",
"13|MIG 130EN WE6523 OEM",
"14|MIG 150EN HTP Replacement",
"15|MIG 160EN HTP Replacement Model 1",
"16|MIG 160EN HTP Replacement Model 2",
"17|MIG 180EN WE6524 HTP Replacement",
"18|MIG 180EN WE6524 OEM",
"19|MIG 190EN WE6484 HTP Replacement",
"20|MIG 190EN WE6484 OEM",
"21|MIG 220T WE6498 HTP Replacement",
"22|MIG 220T WE6498A HTP Replacement",
"23|MIG 265T WE6513A HTP Replacement",
"24|Turbo Weld 235E HTP Replacement");//Clarke Models - MIG

var ModelArray12 = new Array("1|196 205090 HTP Flex",
"2|196 205090 HTP Replacement",
"3|20100 117-032 HTP Flex",
"4|20100 117-032 HTP Replacement",
"5|20100 117-032 OEM",
"6|20101 117-015 HTP Flex",
"7|20101 117-015 HTP Replacement",
"8|20101 117-015 OEM",
"9|20101 117-044 HTP Flex",
"10|20101 117-044 HTP Replacement",
"11|20101 117-044 OEM",
"12|20102 117-007 HTP Flex",
"13|20102 117-007 HTP Replacement",
"14|20102 117-007 OEM",
"15|20104 117-021 HTP Flex",
"16|20104 117-021 HTP Replacement",
"17|20104 117-021 OEM",
"18|20104 117-041 HTP Flex",
"19|20104 117-041 HTP Replacement",
"20|20104 117-041 OEM",
"21|20105 117-047 HTP Flex",
"22|20105 117-047 HTP Replacement",
"23|20105 117-047 OEM",
"24|20111 117-050 HTP Flex",
"25|20111 117-050 HTP Replacement",
"26|20111 117-050 OEM",
"27|20504 HTP Replacement",
"28|20511 117-076 HTP Replacement",
"29|20549 117-053 HTP Flex",
"30|20549 117-053 HTP Replacement",
"31|20549 117-053 OEM",
"32|20559 117-078 HTP Replacement",
"33|20569 HTP Replacement");//Craftsman Models - MIG

var ModelArray13 = new Array("1|140 HTP Replacement",
"2|140-195 HTP Replacement",
"3|140-200 HTP Replacement",
"4|141 HTP Replacement",
"5|142 HTP Replacement",
"6|145 HTP Replacement",
"7|160 HTP Replacement",
"8|165 HTP Replacement",
"9|195 HTP Replacement",
"10|200 HTP Replacement",
"11|240 HTP Replacement",
"12|255 HTP Replacement");//Dan MIG Models - MIG

var ModelArray14 = new Array("1|3Z836 117-005 HTP Replacement",
"2|3Z836A 117-005 HTP Replacement",
"3|3Z913 117-007 HTP Flex",
"4|3Z913 117-007 HTP Replacement",
"5|3Z913 117-007 OEM",
"6|3Z913A 117-021 HTP Flex",
"7|3Z913A 117-021 HTP Replacement",
"8|3Z913A 117-021 OEM",
"9|3Z913B 117-041 HTP Flex",
"10|3Z913B 117-041 HTP Replacement",
"11|3Z913B 117-041 OEM",
"12|3Z913C 117-041 HTP Flex",
"13|3Z913C 117-041 HTP Replacement",
"14|3Z913C 117-041 OEM",
"15|3Z913D 117-041 HTP Flex",
"16|3Z913D 117-041 HTP Replacement",
"17|3Z913D 117-041 OEM",
"18|3Z913E 117-051 HTP Flex",
"19|3Z913E 117-051 HTP Replacement",
"20|3Z913E 117-051 OEM",
"21|3Z914 117-009 HTP Replacement",
"22|3Z914 117-009 OEM",
"23|3Z914A 117-037 HTP Replacement",
"24|3Z914A 117-037 OEM",
"25|3Z914B 117-037 HTP Replacement",
"26|3Z914B 117-037 OEM",
"27|3Z914C 117-037 HTP Replacement",
"28|3Z914C 117-037 OEM",
"29|5Z136 117-042 HTP Replacement",
"30|5Z136 117-042 OEM",
"31|5Z136A 117-042 HTP Replacement",
"32|5Z136A 117-042 OEM",
"33|6Z935 117-032 HTP Flex",
"34|6Z935 117-032 HTP Replacement",
"35|6Z935 117-032 OEM",
"36|6Z935A 117-050 HTP Flex",
"37|6Z935A 117-050 HTP Replacement",
"38|6Z935A 117-050 OEM",
"39|6Z935B 117-050 HTP Flex",
"40|6Z935B 117-050 HTP Replacement",
"41|6Z935B 117-050 OEM",
"42|6Z935C HTP Flex",
"43|6Z935C HTP Replacement",
"44|6Z935C OEM",
"45|6Z935D HTP Replacement Model 1",
"46|6Z935D HTP Replacement Model 2");//Dayton Models - MIG

var ModelArray15 = new Array("1|FAB 155 MIG HTP Replacement",
"2|MIG 160 HTP Replacement",
"3|MIG 171 HTP Replacement",
"4|MIG 175 HTP Replacement",
"5|MIG 180 HTP Replacement",
"6|MIG 181C HTP Replacement",
"7|MIG BOSS 250 MIG-TIG HTP Flex",
"8|MIG BOSS 250 MIG-TIG HTP Replacement");//Daytona MIG Models - MIG

var ModelArray16 = new Array("1|MIG 135 HTP Flex",
"2|MIG 135 HTP Replacement",
"3|MIG 175 HTP Flex",
"4|MIG 175 HTP Replacement");//Eastwood Models - MIG

var ModelArray17 = new Array("1|MIGMaster 150 HTP Replacement Model 1",
"2|MIGMaster 150 HTP Replacement Model 2",
"3|MIGMaster 173 HTP Flex",
"4|MIGMaster 173 HTP Replacement Model 1",
"5|MIGMaster 173 HTP Replacement Model 2",
"6|MIGMaster 203 HTP Flex",
"7|MIGMaster 203 HTP Replacement Model 1",
"8|MIGMaster 203 HTP Replacement Model 2",                             
"9|MIGMaster 250 HTP Flex",
"10|MIGMaster 250 HTP Replacement Model 1",
"11|MIGMaster 250 HTP Replacement Model 2",
"12|MIGMaster 251 HTP Flex",
"13|MIGMaster 251 HTP Replacement Model 1",
"14|MIGMaster 251 HTP Replacement Model 2",
"15|MIGMaster 253 HTP Flex",
"16|MIGMaster 253 HTP Replacement Model 1",
"17|MIGMaster 253 HTP Replacement Model 2",
"18|REBEL EM 215ic HTP Flex",
"19|REBEL EM 215ic HTP Replacement",
"20|REBEL EMP 215ic HTP Flex",
"21|REBEL EMP 215ic HTP Replacement",
"22|REBEL EMS 215ic HTP Flex",
"23|REBEL EMS 215ic HTP Replacement");//ESAB Models - MIG

var ModelArray18 = new Array("1|Power i-MIG 140E HTP Replacement",
"2|Power i-MIG 200 HTP Replacement",
"3|Power i-MIG 200E HTP Replacement",
"4|Power i-MIG 205 HTP Flex",
"5|Power i-MIG 205 HTP Replacement",
"6|Power i-MIG 205P HTP Flex",
"7|Power i-MIG 205P HTP Replacement",
"8|Power i-MIG 275P HTP Replacement",
"9|Power i-MIG 275S HTP Replacement",
"10|PowerMTS 200 HTP Replacement",
"11|PowerMTS 211Si HTP Replacement",
"12|PowerMTS 211STi HTP Replacement",
"13|PowerMTS 251Si HTP Flex",
"14|PowerMTS 251Si HTP Replacement",
"15|PowerMTS 252 HTP Flex",
"16|PowerMTS 252 HTP Replacement");//Everlast Models - MIG

var ModelArray19 = new Array("1|FP-120 1444-0304 HTP Replacement",
"2|FP-125 1444-0324 HTP Replacement",
"3|FP-125 1444-0324 OEM",
"4|FP-130 1444-0306 HTP Replacement",
"5|FP-135 1444-0326 HTP Replacement",
"6|FP-135 1444-0326 OEM",
"7|FP-160 1444-0308 HTP Replacement",
"8|FP-165 1444-0328 HTP Replacement",
"9|FP-165 1444-0328 OEM",
"10|FP-200 1444-0310 HTP Replacement",
"11|FP-260 1444-0312 HTP Replacement",
"12|MST 140i HTP Replacement",
"13|MST 180i HTP Replacement",
"14|MST 220i HTP Replacement");//Firepower Models - MIG

var ModelArray20 = new Array("1|MIG 210 HTP Replacement",
"2|MIG 210 OEM");//Forney Models - MIG

var ModelArray21 = new Array("1|MIG 1000 HTP Replacement",
"2|MIG 160 HTP Replacement",
"3|MIG 160A HTP Replacement",
"4|MIG 2000 HTP Replacement");//Henning Hanson Models - MIG

var ModelArray22 = new Array("1|BETA-MIG 170 HTP Flex",
"2|BETA-MIG 170 HTP Replacement",
"3|BETA-MIG 1800 Built Before February 2000 HTP Replacement",
"4|BETA-MIG 1800 Built February 2000 and Later HTP Replacement",
"5|BETA-MIG 200 HTP Replacement",
"6|BETA-MIG 250 HTP Replacement",
"7|BETA-MIG 251 HTP Replacement",
"8|BETA-MIG 2510 HTP Flex",
"9|BETA-MIG 2510 HTP Replacement",
"10|BETA-MIG 2510 OEM",
"11|Handler 120 HTP Flex",
"12|Handler 120 HTP Replacement",
"13|Handler 130XL HTP Flex",
"14|Handler 130XL HTP Replacement",
"15|Handler 135 HTP Flex",
"16|Handler 135 HTP Replacement",
"17|Handler 135 OEM",
"18|Handler 140 HTP Flex",
"19|Handler 140 HTP Replacement",
"20|Handler 140 OEM",
"21|Handler 150 HTP Flex",
"22|Handler 150 HTP Replacement",
"23|Handler 175 HTP Flex",
"24|Handler 175 HTP Replacement",
"25|Handler 175 OEM",
"26|Handler 180 HTP Flex",
"27|Handler 180 HTP Replacement",
"28|Handler 180 OEM",
"29|Handler 187 HTP Flex",
"30|Handler 187 HTP Replacement",
"31|Handler 187 OEM",
"32|Handler 190 HTP Replacement",
"33|Handler 190 HTP Flex",
"34|Handler 190 OEM",
"35|Handler 210 HTP Replacement",
"36|Handler 210 HTP Flex",
"37|Handler 210 OEM",
"38|Handler 210 MVP HTP Replacement",
"39|Handler 210 MVP HTP Flex",
"40|Handler 210 MVP OEM",
"41|Handler HTP Flex",
"42|Handler HTP Replacement",
"43|IronMan 210 HTP Flex",
"44|IronMan 210 HTP Replacement",
"45|IronMan 210 OEM",
"46|IronMan 230 HTP Flex",
"47|IronMan 230 HTP Replacement",
"48|IronMan 230 OEM",
"49|IronMan 250 HTP Flex",
"50|IronMan 250 HTP Replacement",
"51|IronMan 250 OEM",
"52|IronMan 275 HTP Flex",
"53|IronMan 275 HTP Replacement",
"54|IronMan 275 OEM",
"55|MIG-MAN HTP Flex",
"56|MIG-MAN HTP Replacement",
"57|Trek 180 HTP Flex",
"58|Trek 180 HTP Replacement",
"59|Trek 180 OEM",
"60|H100S2-10",
"61|H100S4-10",
"62|H200L4-15",
"63|Piecemaker 14A");//Hobart Models - MIG



var ModelArray23 = new Array("1|Easy-Core 125 HTP Flex",
"2|Easy-Core 125 HTP Replacement",
"3|Easy-Core 125 OEM",
"4|EasyMIG 140 HTP Flex",
"5|EasyMIG 140 HTP Replacement",
"6|EasyMIG 140 OEM",
"7|EasyMIG 180 HTP Flex",
"8|EasyMIG 180 HTP Replacement",
"9|EasyMIG 180 OEM",
"10|Handymig 170i HTP Flex",
"11|Handymig 170i HTP Replacement",
"12|Handymig 170i OEM",
"13|LN25 HTP Replacement",
"14|LN4 HTP Replacement",
"15|LN7 HTP Replacement",
"16|MIG-PAK 10 HTP Flex",
"17|MIG-PAK 10 HTP Replacement",
"18|MIG-PAK 10 OEM",
"19|MIG-PAK 140 HTP Flex",
"20|MIG-PAK 140 HTP Replacement",
"21|MIG-PAK 140 OEM",
"22|MIG-PAK 15 HTP Flex",
"23|MIG-PAK 15 HTP Replacement",
"24|MIG-PAK 15 OEM",
"25|MIG-PAK 180 HTP Flex",
"26|MIG-PAK 180 HTP Replacement",
"27|MIG-PAK 180 OEM",
"28|POWER MIG 140C HTP Flex",
"29|POWER MIG 140C HTP Replacement",
"30|POWER MIG 140C OEM",
"31|POWER MIG 140T HTP Flex",
"32|POWER MIG 140T HTP Replacement",
"33|POWER MIG 140T OEM",
"34|POWER MIG 180 DUAL HTP Flex",
"35|POWER MIG 180 DUAL HTP Replacement",
"36|POWER MIG 180 DUAL OEM",
"37|POWER MIG 180C HTP Flex",
"38|POWER MIG 180C HTP Replacement",
"39|POWER MIG 180C OEM",
"40|POWER MIG 180T HTP Flex",
"41|POWER MIG 180T HTP Replacement",
"42|POWER MIG 180T OEM",
"43|POWER MIG 200 HTP Flex",
"44|POWER MIG 200 HTP Replacement",
"45|POWER MIG 200 OEM",
"46|POWER MIG 210 MP HTP Flex",
"47|POWER MIG 210 MP HTP Replacement",
"48|POWER MIG 210 MP OEM",
"49|POWER MIG 215 HTP Flex",
"50|POWER MIG 215 HTP Replacement",
"51|POWER MIG 215 OEM",
"52|POWER MIG 216 HTP Flex",
"53|POWER MIG 216 HTP Replacement",
"54|POWER MIG 216 OEM",
"55|POWER MIG 255 HTP Flex",
"56|POWER MIG 255 HTP Replacement",
"57|POWER MIG 255 OEM",
"58|POWER MIG 255XT HTP Flex",
"59|POWER MIG 255XT HTP Replacement",
"60|POWER MIG 255XT OEM",
"61|POWER MIG 256 HTP Flex",
"62|POWER MIG 256 HTP Replacement",
"63|POWER MIG 256 OEM",
"64|POWER MIG 350MP HTP Flex",
"65|POWER MIG 350MP HTP Replacement",
"66|POWER MIG 350MP OEM",
"67|PRO 100 HTP Flex",
"68|PRO 100 HTP Replacement",
"69|PRO 100 OEM",
"70|PRO 155 HTP Flex",
"71|PRO 155 HTP Replacement",
"72|PRO 155 OEM",
"73|PRO-CORE 100 HTP Flex",
"74|PRO-CORE 100 HTP Replacement",
"75|PRO-CORE 100 OEM",
"76|PRO-CORE 125 HTP Flex",
"77|PRO-CORE 125 HTP Replacement",
"78|PRO-CORE 125 OEM",
"79|PRO-MIG 135 HTP Flex",
"80|PRO-MIG 135 HTP Replacement",
"81|PRO-MIG 135 OEM",
"82|PRO-MIG 140 CODE 11128 HTP Flex",
"83|PRO-MIG 140 CODE 11128 HTP Replacement",
"84|PRO-MIG 140 CODE 11128 OEM",
"85|PRO-MIG 140 EXCEPT CODE 11128 HTP Flex",
"86|PRO-MIG 140 EXCEPT CODE 11128 HTP Replacement",
"87|PRO-MIG 140 EXCEPT CODE 11128 OEM",
"88|PRO-MIG 175 HTP Flex",
"89|PRO-MIG 175 HTP Replacement",
"90|PRO-MIG 175 OEM",
"91|PRO-MIG 180 HTP Flex",
"92|PRO-MIG 180 HTP Replacement",
"93|PRO-MIG 180 OEM",
"94|PRO-MIG 255C CODE 11192 HTP Flex",
"95|PRO-MIG 255C CODE 11192 HTP Replacement",
"96|PRO-MIG 255C CODE 11192 OEM",
"97|SP-100 HTP Flex",
"98|SP-100 HTP Replacement",
"99|SP-100 OEM",
"100|SP-100T HTP Flex",
"101|SP-100T HTP Replacement",
"102|SP-100T OEM",
"103|SP-125 PLUS HTP Flex",
"104|SP-125 PLUS HTP Replacement",
"105|SP-125 PLUS OEM",
"106|SP-130T HTP Flex",
"107|SP-130T HTP Replacement",
"108|SP-130T OEM",
"109|SP-135 PLUS HTP Flex",
"110|SP-135 PLUS HTP Replacement",
"111|SP-135 PLUS OEM",
"112|SP-135T HTP Flex",
"113|SP-135T HTP Replacement",
"114|SP-135T OEM",
"115|SP-140T HTP Flex",
"116|SP-140T HTP Replacement",
"117|SP-140T OEM",
"118|SP-150 HTP Replacement",
"119|SP-155 HTP Flex",
"120|SP-155 HTP Replacement",
"121|SP-155 OEM",
"122|SP-170 HTP Flex",
"123|SP-170 HTP Replacement",
"124|SP-170 OEM",
"125|SP-170T HTP Flex",
"126|SP-170T HTP Replacement",
"127|SP-170T OEM",
"128|SP-175 PLUS HTP Flex",
"129|SP-175 PLUS HTP Replacement",
"130|SP-175 PLUS OEM",
"131|SP-175T HTP Flex",
"132|SP-175T HTP Replacement",
"133|SP-175T OEM",
"134|SP-180T HTP Flex",
"135|SP-180T HTP Replacement",
"136|SP-180T OEM",
"137|SP-200 HTP Replacement",
"138|SP-250 HTP Replacement",
"139|SP-255 HTP Replacement",
"140|SP-85 HTP Flex",
"141|SP-85 HTP Replacement",
"142|SP-85 OEM",
"143|Speedtec 200C HTP Flex",
"144|Speedtec 200C HTP Replacement",
"145|WELDMARK 135 PLUS HTP Flex",
"146|WELDMARK 135 PLUS HTP Replacement",
"147|WELDMARK 135 PLUS OEM",
"148|WELD-PAK 100 HTP Flex",
"149|WELD-PAK 100 HTP Replacement",
"150|WELD-PAK 100HD HTP Flex",
"151|WELD-PAK 100HD HTP Replacement",
"152|WELD-PAK 100HD OEM",
"153|WELD-PAK 125 HTP Flex",
"154|WELD-PAK 125 HTP Replacement",
"155|WELD-PAK 125 OEM",
"156|WELD-PAK 125HD HTP Flex",
"157|WELD-PAK 125HD HTP Replacement",
"158|WELD-PAK 125HD OEM",
"159|WELD-PAK 140HD HTP Flex",
"160|WELD-PAK 140HD HTP Replacement",
"161|WELD-PAK 140HD OEM",
"162|WELD-PAK 155 HTP Flex",
"163|WELD-PAK 155 HTP Replacement",
"164|WELD-PAK 155 OEM",
"165|WELD-PAK 175HD HTP Flex",
"166|WELD-PAK 175HD HTP Replacement",
"167|WELD-PAK 175HD OEM",
"168|WELD-PAK 180HD HTP Flex",
"169|WELD-PAK 180HD HTP Replacement",
"170|WELD-PAK 180HD OEM",
"171|WELD-PAK 3200HD HTP Flex",
"172|WELD-PAK 3200HD HTP Replacement",
"173|WELD-PAK 3200HD OEM",
"174|WELD-PAK 5000HD HTP Flex",
"175|WELD-PAK 5000HD HTP Replacement",
"176|WELD-PAK 5000HD OEM",
"177|WIRE-MATIC 250 HTP Flex",
"178|WIRE-MATIC 250 HTP Replacement",
"179|WIRE-MATIC 250 OEM",
"180|WIRE-MATIC 255 HTP Flex",
"181|WIRE-MATIC 255 HTP Replacement",
"182|WIRE-MATIC 255 OEM",
"183|Work-Pak 125 HTP Flex",
"184|Work-Pak 125 HTP Replacement",
"185|Work-Pak 125 OEM",
"186|MAGNUM 100L",
"187|MAGNUM PRO 100L",
"188|MAGNUM PRO 175L");//LINCOLN Models - MIG

var ModelArray24 = new Array("1|ArcMate 205P HTP Replacement",
"2|MIGWELD 140 HTP Flex",
"3|MIGWELD 140 HTP Replacement",
"4|MIGWELD 140 OEM",
"5|MIGWELD 200S HTP Flex",
"6|MIGWELD 200S HTP Replacement",
"7|MIGWELD 200S OEM",
"8|MIGWELD 250MP HTP Flex",
"9|MIGWELD 250MP HTP Replacement",
"10|MIGWELD 250P HTP Flex",
"11|MIGWELD 250P HTP Replacement",
"12|Pro MTS 200 HTP Replacement",
"13|Pro MTS 200i HTP Replacement",
"14|ProMTS 252i HTP Flex",
"15|ProMTS 252i HTP Replacement");//Longevity Models - MIG

var ModelArray25 = new Array("1|MIG 140 HTP Flex",
"2|MIG 140 HTP Replacement");//LOTOS Models - MIG
 
 var ModelArray26 = new Array("1|MIG 250 HTP Flex",
"2|MIG 250 HTP Replacement Model 1",
"3|MIG 250 HTP Replacement Model 2",
"4|MIGMaster 250 HTP replacement");//L-TEC Models - MIG

 var ModelArray27 = new Array("1|MW130A HTP Flex",
"2|MW130A HTP Replacement",
"3|MW135 HTP Flex",
"4|MW135 HTP Replacement",
"5|MW135X HTP Flex",
"6|MW135X HTP Replacement",
"7|MW135X OEM",
"8|MW140 Plus HTP Flex",
"9|MW140 Plus HTP Replacement",
"10|MW140 Plus OEM",
"11|MW145 HTP Flex",
"12|MW145 HTP Replacement",
"13|MW145A HTP Flex",
"14|MW145A HTP Replacement",
"15|MW145N HTP Replacement",
"16|MW150 HTP Flex",
"17|MW150 HTP Replacement",
"18|MW150K HTP Flex",
"19|MW150K HTP Replacement",
"20|MW165 HTP Flex",
"21|MW165 HTP Replacement",
"22|MW165A HTP Replacement",
"23|MW175 SN KF975790 and Up HTP Flex",
"24|MW175 SN KF975790 and Up HTP Replacement",
"25|MW175 HTP Flex",
"26|MW175 HTP Replacement",
"27|MW175X HTP Flex",
"28|MW175X HTP Replacement",
"29|MW175X OEM",
"30|MW180 Plus HTP Flex",
"31|MW180 Plus HTP Replacement",
"32|MW180 Plus OEM",
"33|MW185 Plus HTP Flex",
"34|MW185 Plus HTP Replacement",
"35|MW185 Plus OEM",
"36|MW185N HTP Replacement",
"37|MW225 HTP Flex",
"38|MW225 HTP Replacement",
"39|MW250 HTP Flex",
"40|MW250 HTP Replacement",
"41|MW250X HTP Flex",
"42|MW250X HTP Replacement",
"43|MW250X OEM",
"44|MW260X HTP Flex",
"45|MW260X HTP Replacement",
"46|MW260X OEM",
"47|MW270 Plus HTP Flex",
"48|MW270 Plus HTP Replacement",
"49|MW270 Plus OEM",
"50|MW275N HTP Replacement",
"51|MW275X HTP Flex",
"52|MW275X HTP Replacement",
"53|MW275X OEM",
"54|WS007K HTP Flex",
"55|WS007K HTP Replacement",
"56|WS007K OEM",
"57|WS1110 HTP Replacement Model 1",
"58|WS1110 HTP Replacement Model 2",
"59|WS117 HTP Flex",
"60|WS117 HTP Replacement",
"61|WS117 OEM",
"62|WS117K HTP Flex",
"63|WS117K HTP Replacement",
"64|WS117K OEM",
"65|WS120 HTP Flex",
"66|WS120 HTP Replacement",
"67|WS120 OEM",
"68|WS1300 MAC MIG HTP Replacement Model 1",
"69|WS1300 MAC MIG HTP Replacement Model 2",
"70|WS225K 117-018 HTP Replacement",
"71|WS225K 117-018 OEM",
"72|WS225K 117-042 HTP Replacement",
"73|WS225K 117-042 OEM");//MAC Tools - MIG

 var ModelArray28 = new Array("1|M02155 HTP Replacement",
"2|M02160 HTP Flex",
"3|M02160 HTP Replacement",
"4|M02160 OEM",
"5|M02170 HTP Replacement",
"6|M02185 HTP Replacement Model 1",
"7|M02185 HTP Replacement Model 2",
"8|M02199  117-089  HTP Replacement",
"9|M02230  117-090  HTP Replacement",
"10|M12175 HTP Flex",
"11|M12175 HTP Replacement",
"12|M12175 OEM",
"13|M12178 HTP Replacement Model 1",
"14|M12178 HTP Replacement Model 2",
"15|M12179 HTP Replacement Model 1",
"16|M12179 HTP Replacement Model 2",
"17|M12180 HTP Replacement Model 1",
"18|M12180 HTP Replacement Model 2",
"19|M12183 HTP Replacement",
"20|M12184 HTP Replacement",
"21|M12185 HTP Flex",
"22|M12185 HTP Replacement",
"23|M12190 HTP Replacement",
"24|M12205 HTP Replacement",
"25|M12208 HTP Replacement",
"26|M12209 HTP Replacement",
"27|M12210 HTP Flex",
"28|M12210 HTP Replacement",
"29|M12211 HTP Flex",
"30|M12211 HTP Replacement");//Marquette - MIG

 var ModelArray29 = new Array("1|MG145 HTP Replacement",
"2|MG180 HTP Replacement",
"3|MIG 140 HTP Replacement",
"4|MIG 170 HTP Replacement",
"5|MP140 HTP Flex",
"6|MP140 HTP Replacement",
"7|MP140 OEM",
"8|MP240 HTP Flex",
"9|MP240 HTP Replacement",
"10|MP240 OEM",
"11|WF225 117-018 HTP Flex",
"12|WF225 117-018 HTP Replacement",
"13|WF225 117-018 OEM",
"14|WF225 117-042 HTP Flex",
"15|WF225 117-042 HTP Replacement",
"16|WF225 117-042 OEM",
"17|WFFC 117-055 HTP Flex",
"18|WFFC 117-055 HTP Replacement",
"19|WFFC 117-055 OEM",
"20|WFW1 117-015 HTP Flex",
"21|WFW1 117-015 HTP Replacement",
"22|WFW1 117-015 OEM",
"23|WFW1 117-044 HTP Flex",
"24|WFW1 117-044 HTP Replacement",
"25|WFW1 117-044 OEM",
"26|WFW12179 HTP Replacement Model 1",
"27|WFW12179 HTP Replacement Model 2",
"28|WFW140 117-059 HTP Flex",
"29|WFW140 117-059 HTP Replacement",
"30|WFW140 117-059 OEM",
"31|WFW150 HTP Replacement",
"32|WFW160 117-067 HTP Flex",
"33|WFW160 117-067 HTP Replacement",
"34|WFW160 117-067 OEM",
"35|WFW170 117-087 HTP Replacement",
"36|WFW250 117-062 HTP Flex",
"37|WFW250 117-062 HTP Replacement",
"38|WFW250 117-062 OEM",
"39|WFWM 117-030 HTP Flex",
"40|WFWM 117-030 HTP Replacement",
"41|WFWM 117-030 OEM",
"42|WFWM 117-038 HTP Flex",
"43|WFWM 117-038 HTP Replacement",
"44|WFWM 117-038 OEM",
"45|WFWMDP 117-051 HTP Flex",
"46|WFWMDP 117-051 HTP Replacement",
"47|WFWMDP 117-051 OEM",
"48|WFWT 117-027 HTP Flex",
"49|WFWT 117-027 HTP Replacement",
"50|WFWT 117-027 OEM");//MATCO - MIG

 var ModelArray30 = new Array("1|Cricket HTP Flex",
"2|Cricket HTP Replacement",
"3|Cricket XL HTP Flex",
"4|Cricket XL HTP Replacement",
"5|Gold Seal 420 HTP Flex",
"6|Gold Seal 420 HTP Replacement",
"7|Gold Seal 420 OEM",
"8|Gold Seal 422 HTP Flex",
"9|Gold Seal 422 HTP Replacement",
"10|Gold Seal 442 HTP Flex",
"11|Gold Seal 442 HTP Replacement",
"12|Millermatic 120 HTP Flex",
"13|Millermatic 120 HTP Replacement",
"14|Millermatic 120 OEM",
"15|Millermatic 125 HTP Flex",
"16|Millermatic 125 HTP Replacement",
"17|Millermatic 125 OEM",
"18|Millermatic 130 HTP Flex",
"19|Millermatic 130 HTP Replacement",
"20|Millermatic 130XP HTP Flex",
"21|Millermatic 130XP HTP Replacement",
"22|Millermatic 130XP OEM",
"23|Millermatic 135 HTP Flex",
"24|Millermatic 135 HTP Replacement",
"25|Millermatic 135 OEM",
"26|Millermatic 140 HTP Flex",
"27|Millermatic 140 HTP Replacement",
"28|Millermatic 140 OEM",
"29|Millermatic 140 w-Auto-Set HTP Flex",
"30|Millermatic 140 w-Auto-Set HTP Replacement",
"31|Millermatic 140 w-Auto-Set OEM",
"32|Millermatic 141 HTP Flex",
"33|Millermatic 141 HTP Replacement",
"34|Millermatic 141 OEM",
"35|Millermatic 150 HTP Flex",
"36|Millermatic 150 HTP Replacement",
"37|Millermatic 175 HTP Flex",
"38|Millermatic 175 HTP Replacement",
"39|Millermatic 175 OEM",
"40|Millermatic 180 HTP Flex",
"41|Millermatic 180 HTP Replacement",
"42|Millermatic 180 OEM",
"43|Millermatic 180 w-Auto-Set HTP Flex",
"44|Millermatic 180 w-Auto-Set HTP Replacement",
"45|Millermatic 180 w-Auto-Set OEM",
"46|Millermatic 185 HTP Flex",
"47|Millermatic 185 HTP Replacement",
"48|Millermatic 185 OEM",
"49|Millermatic 190 HTP Flex",
"50|Millermatic 190 HTP Replacement",
"51|Millermatic 190 OEM",
"52|Millermatic 200 HTP Flex",
"53|Millermatic 200 HTP Replacement",
"54|Millermatic 200 OEM",
"55|Millermatic 210 HTP Flex",
"56|Millermatic 210 HTP Replacement",
"57|Millermatic 210 OEM",
"58|Millermatic 211 HTP Flex",
"59|Millermatic 211 HTP Replacement",
"60|Millermatic 211 OEM",                                                        
"61|Millermatic 212 HTP Flex",
"62|Millermatic 212 HTP Replacement",
"63|Millermatic 212 OEM",
"64|Millermatic 250 HTP Flex",
"65|Millermatic 250 HTP Replacement",
"66|Millermatic 250 OEM",
"67|Millermatic 250X HTP Flex",
"68|Millermatic 250X HTP Replacement",
"69|Millermatic 250X OEM",
"70|Millermatic 251 HTP Flex",
"71|Millermatic 251 HTP Replacement",
"72|Millermatic 251 OEM",
"73|Millermatic 252 HTP Flex",
"74|Millermatic 252 HTP Replacement",
"75|Millermatic 252 OEM",
"76|Millermatic 35 JA448186 and Up HTP Flex",
"77|Millermatic 35 JA448186 and Up HTP Replacement",
"78|Millermatic 35 JA448186 and Up OEM",
"79|Millermatic 90 HTP Flex",
"80|Millermatic 90 HTP Replacement",
"81|Millermatic Challenger 172 HTP Flex",
"82|Millermatic Challenger 172 HTP Replacement",
"83|Millermatic Challenger 172 OEM",
"84|Millermatic Challenger HTP Flex",
"85|Millermatic Challenger HTP Replacement",
"86|Millermatic Challenger OEM",
"87|Millermatic DVI HTP Flex",
"88|Millermatic DVI HTP Replacement",
"89|Millermatic DVI OEM",
"90|Millermatic Passport HTP Flex",
"91|Millermatic Passport HTP Replacement",
"92|Millermatic Passport OEM",
"93|Millermatic Passport Plus HTP Flex",
"94|Millermatic Passport Plus HTP Replacement",
"95|Millermatic Passport Plus OEM",
"96|Millermatic Pulser HTP Flex",
"97|Millermatic Pulser HTP Replacement",
"98|Millermatic Pulser OEM",
"99|Millermatic Vintage HTP Flex",
"100|Millermatic Vintage HTP Replacement",
"101|Millermatic Vintage OEM",
"102|Sidekick HTP Flex",
"103|Sidekick HTP Replacement",
"104|Sidekick XL HTP Flex",
"105|Sidekick XL HTP Replacement",
"106|SuitCase 12RC Extreme HTP Flex",
"107|SuitCase 12RC Extreme HTP Replacement",
"108|SuitCase 12RC Extreme OEM",
"109|SuitCase 12VS Extreme HTP Flex",
"110|SuitCase 12VS Extreme HTP Replacement",
"111|SuitCase 12VS Extreme OEM",
"112|10A",
"113|GA16C",
"114|GA17C",
"115|GA20C",
"116|GA21C",
"117|M10",
"118|M15",
"119|M25");//Miller - MIG

 var ModelArray31 = new Array("1|83-210 HTP Replacement Model 1",
"2|83-210 HTP Replacement Model 2",
"3|83-310 HTP Replacement",
"4|83-317 HTP Replacement",
"5|83-318 HTP Replacement",
"6|83-319 HTP Replacement ",
"7|83-320 HTP Replacement",
"8|83-327 HTP Replacement",
"9|83-360 HTP Replacement",                          
"10|83-363 HTP Replacement Model 1",
"11|83-363 HTP Replacement Model 2",
"12|83-369 HTP Replacement",
"13|83-381 HTP Flex",
"14|83-381 HTP Replacement",
"15|83-390 HTP Replacement");//NAPA - MIG

var ModelArray32 = new Array("1|70 117-060 HTP Flex",
"2|70 117-060 HTP Replacement",
"3|70 117-060 OEM",
"4|83100 117-061 HTP Flex",
"5|83100 117-061 HTP Replacement",
"6|83100 117-061 OEM",
"7|83101 117-064 HTP Flex",
"8|83101 117-064 HTP Replacement",
"9|83101 117-064 OEM");//PowerMate - MIG

var ModelArray33 = new Array("1|PR-155 Model 1 HTP Replacement",
"2|PR-155 Model 2 HTP Replacement",
"3|PR-205MV HTP Replacement",
"4|SP-1 HTP Replacement",
"5|SP-2 HTP Replacement Model 1",
"6|SP-2 HTP Replacement Model 2",
"7|SP-5 HTP Replacement Model 1",
"8|SP-5 HTP Replacement Model 2",
"9|SP-5 3 HTP Replacement Model 1",
"10|SP-5 3 HTP Replacement Model 2");//Pro Spot - MIG

var ModelArray34 = new Array("1|180 Turbo MIG HTP Replacement",
"2|90201 HTP Replacement",
"3|93100 HTP Replacement Model 1",
"4|93100 HTP Replacement Model 2",
"5|93140 HTP Replacement Model 1",
"6|93140 HTP Replacement Model 2",
"7|93180 HTP Replacement",
"8|93300 HTP Replacement",
"9|E-Z Flux 90775 HTP Replacement Model 1",
"10|E-Z Flux 90775 HTP Replacement Model 2",
"11|Pro 140 HTP Replacement Model 1",
"12|Pro 140 HTP Replacement Model 2");//Schumacher Electric - MIG

var ModelArray35 = new Array("1|117-007 HTP Flex",
"2|117-007 HTP Replacement",
"3|117-007 OEM",
"4|MIG 160 117-009 HTP Replacement",
"5|MIG 160 117-009 OEM");//SD Lee - MIG

 var ModelArray36 = new Array("1|90070 HTP Replacement Model 1",
"2|90070 HTP Replacement Model 2",
"3|90071 HTP Replacement Model 1",
"4|90071 HTP Replacement Model 2",
"5|90085 HTP Replacement Model 1",
"6|90085 HTP Replacement Model 2",
"7|90430 HTP Replacement",
"8|90440 HTP Replacement Model 1",
"9|90440 HTP Replacement Model 2");//Silver Beauty - MIG

 var ModelArray37 = new Array("1|196 Autoplus Turbo HTP Replacement");//SIP - MIG
 
var ModelArray38 = new Array("1|FM140A HTP Flex",
"2|FM140A HTP Replacement",
"3|FM140A OEM",
"4|MIG 115 HTP Replacement",
"5|MIG 120 HTP Replacement Model 1",
"6|MIG 120 HTP Replacement Model 2",
"7|MIG 125 HTP Replacement",
"8|MIG 135 HTP Replacement",
"9|MIG 160I HTP Flex",
"10|MIG 160I HTP Replacement",
"11|MIG 160I OEM",
"12|MIG 220 HTP Flex",
"13|MIG 220 HTP Replacement",
"14|MIG 220 OEM",
"15|MM120SL HTP Flex",
"16|MM120SL HTP Replacement",
"17|MM120SL OEM",
"18|MM140SL HTP Flex",
"19|MM140SL HTP Replacement",
"20|MM140SL OEM",
"21|MM250SL HTP Flex",
"22|MM250SL HTP Replacement",
"23|MM250SL OEM",
"24|MW120 HTP Flex",
"25|MW120 HTP Replacement",
"26|MW120 OEM",
"27|YA204 HTP Flex",
"28|YA204 HTP Replacement",
"29|YA204 OEM",
"30|YA204A HTP Flex",
"31|YA204A HTP Replacement",
"32|YA204A OEM",
"33|YA205 117-012 HTP Flex",
"34|YA205 117-012 HTP Replacement",
"35|YA205 117-012 OEM",
"36|YA205A 117-031 HTP Flex",
"37|YA205A 117-031 HTP Replacement",
"38|YA205A 117-031 OEM",
"39|YA205B 117-056 HTP Flex",
"40|YA205B 117-056 HTP Replacement",
"41|YA205B 117-056 OEM",
"42|YA212A HTP Flex",
"43|YA212A HTP Replacement",
"44|YA212A OEM",
"45|YA217 117-029 HTP Flex",
"46|YA217 117-029 HTP Replacement",
"47|YA217 117-029 OEM",
"48|YA217A 117-058 HTP Flex",
"49|YA217A 117-058 HTP Replacement",
"50|YA217A 117-058 OEM",
"51|YA219 117-022 HTP Flex",
"52|YA219 117-022 HTP Replacement",
"53|YA219 117-022 OEM",
"54|YA219A HTP Flex",
"55|YA219A HTP Replacement",
"56|YA219A OEM",
"57|YA219B 117-040 HTP Flex",
"58|YA219B 117-040 HTP Replacement",
"59|YA219B 117-040 OEM",
"60|YA219C 117-059 HTP Flex",
"61|YA219C 117-059 HTP Replacement",
"62|YA219C 117-059 OEM",
"63|YA240 117-024 HTP Flex",
"64|YA240 117-024 HTP Replacement",
"65|YA240 117-024 OEM",
"66|YA240A 117-036 HTP Flex",
"67|YA240A 117-036 HTP Replacement",
"68|YA240A 117-036 OEM",
"69|YA240B 117-062 HTP Flex",
"70|YA240B 117-062 HTP Replacement",
"71|YA240B 117-062 OEM");//Snap-on - MIG

var ModelArray39 = new Array("1|2110 117-033 HTP Flex",
"2|2110 117-033 HTP Replacement",
"3|2110 117-033 OEM",
"4|2114 117-045 HTP Flex",
"5|2114 117-045 HTP Replacement",
"6|2114 117-045 OEM",
"7|2115 117-026 HTP Flex",
"8|2115 117-026 HTP Replacement",
"9|2115 117-026 OEM",
"10|2120 117-020 HTP Flex",
"11|2120 117-020 HTP Replacement",
"12|2120 117-020 OEM",
"13|2120 117-043 HTP Flex",
"14|2120 117-043 HTP Replacement",
"15|2120 117-043 OEM",
"16|2125 117-010 HTP Flex",
"17|2125 117-010 HTP Replacement",
"18|2125 117-010 OEM",
"19|2130 117-050 HTP Flex",
"20|2130 117-050 HTP Replacement",
"21|2130 117-050 OEM",
"22|2140 117-053 HTP Flex",
"23|2140 117-053 HTP Replacement",
"24|2140 117-053 OEM",
"25|2145 HTP Replacement Model 1",
"26|2145 HTP Replacement Model 2",
"27|2150 117-051 HTP Flex",
"28|2150 117-051 HTP Replacement",
"29|2150 117-051 OEM",
"30|2155 HTP Replacement Model 1",
"31|2155 HTP Replacement Model 2",
"32|2160 117-067 HTP Flex",
"33|2160 117-067 HTP Replacement",
"34|2160 117-067 OEM",
"35|2165 117-003 HTP Replacement",
"36|2171 HTP Replacement Model 1",
"37|2171 HTP Replacement Model 2",
"38|2172 HTP Replacement Model 1",
"39|2172 HTP Replacement Model 2",
"40|2175 117-011 HTP Flex",
"41|2175 117-011 HTP Replacement",
"42|2175 117-011 OEM",
"43|2175 117-039 HTP Flex",
"44|2175 117-039 HTP Replacement",
"45|2175 117-039 OEM",
"46|2185 HTP Replacement Model 1",
"47|2185 HTP Replacement Model 2",
"48|2225 117-023 HTP Replacement",
"49|2225 117-023 OEM",
"50|2225 117-035 HTP Replacement",
"51|2225 117-035 OEM");//Solar - MIG

var ModelArray40 = new Array("1|MP140 HTP Flex",
"2|MP140 HTP Replacement",
"3|MP140 OEM",
"4|MP175 HTP Flex",
"5|MP175 HTP Replacement",
"6|MP175 OEM",
"7|MP250 HTP Flex",
"8|MP250 HTP Replacement",
"9|MP250 OEM",
"10|PBE140 HTP Flex",
"11|PBE140 HTP Replacement",
"12|PBE140 OEM",
"13|PBE180 HTP Flex",
"14|PBE180 HTP Replacement",
"15|PBE180 OEM",
"16|PBE250 HTP Flex",
"17|PBE250 HTP Replacement",
"18|PBE250 OEM");//Systematics - MIG

 var ModelArray41 = new Array("1|Fabricator 181i HTP Flex",
"2|Fabricator 181i HTP Replacement",
"3|Fabricator 211i HTP Flex",
"4|Fabricator 211i HTP Replacement");//Thermal Arc - MIG
                              
 var ModelArray42 = new Array("1|MIG 140 Professional 180A Gun",
"2|MIG 170 Professional 180A Gun",
"3|Unlimited 200 Professional 180A Gun");//Titanium - MIG

 var ModelArray43 = new Array("1|Mini MIG",
"2|1",
"3|2",
"4|3",
"5|4",
"6|Fabricator 181i HTP Flex",
"7|Fabricator 181i HTP Replacement",
"8|Fabricator 211i HTP Flex",                             
"9|Fabricator 211i HTP Replacement");//Tweco - MIG

var ModelArray44 = new Array("1|MIGMax 215 HTP Flex",
"2|MIGMax 215 HTP Replacement",
"3|OmniPro 220 HTP Flex",
"4|OmniPro 220 HTP Replacement");//Vulcan - MIG

var ModelArray45 = new Array("1|MIG 140 HTP Flex",
"2|MIG 140 HTP Replacement",
"3|MIG 140 OEM");//Weldmart Models - MIG// JavaScript Document


function loadBrand()
{
	var selectBrand = document.getElementById("selectBrand");

	if (selectBrand != null && BrandArray != null)
	{
		loadOptions(selectBrand, BrandArray, "- Brand -");	
	}	
}

function loadOptions(select, list, initOption)
{
	if (select != null && list != null)
	{
		select.options.length = 0;
		select.options[select.options.length] = new Option(initOption, "-1");
		for (i = 0; i < list.length; i++)
		{
			var opt = list[i].split("|");
			select.options[select.options.length] = new Option(opt[1], opt[0]);
		}
	}
}

function loadJoes(select, list, initOption)
{
	if (select != null && list != null)
	{
		select.options.length = 0;
		select.options[select.options.length] = new Option(initOption, "-1");
		for (i = 0; i < list.length; i++)
		{
			var opt = list[i];
			select.options[select.options.length] = new Option(opt, opt);
		}
	}
}

function resetSelect(select)
{
	var btnSearch = document.getElementById("btnSearch");

	select.options[0].selected = true;
	select.disabled = true;
	btnSearch.disabled = true;
}

function changeBrand()
{
	var selectBrand = document.getElementById("selectBrand");
	var selectModel = document.getElementById("selectModel");
	var selectJoe = document.getElementById("selectJoe");

		
	if (selectBrand != null)
	{
		if (selectBrand.value != "-1")
		{
			if (selectModel != null)
			{
				loadOptions(selectModel, eval("ModelArray" + selectBrand.value), "- Model -");
				selectModel.disabled = false;
				resetSelect(selectJoe);

			}		
		}
		else
		{
			resetSelect(selectModel);	
			resetSelect(selectJoe);

		}
	}
}

function changeModel()
{
	var selectModel = document.getElementById("selectModel");
	//*var selectJoe = document.getElementById("selectJoe");
	var override = false;

	if (selectModel != null)
	{
		if (selectJoe != null)
		{
			if (selectModel.value != "-1")
			{
				try
				{
					eval("JoeArray" + selectModel.value);
					override = true;
				}
				catch(err)
				{
					override = false;
				}
			
				if (override)
				{
					loadJoes(selectJoe, eval("JoeArray" + selectModel.value), "- Joe -");

				}
				else
				{
					loadJoes(selectJoe, JoeArrayDefault, "- Joe -");

				}
				selectJoe.disabled = false;
			}
			else
			{
				resetSelect(selectJoe);

			}
		}
	}
	else
	{
		resetSelect(selectJoe);
	}
}

function changeJoe()
{
	var selectJoe = document.getElementById("selectJoe");
	var btnSearch = document.getElementById("btnSearch");
	var override = false;

	if (selectJoe != null)
	{
		if (selectJoe.value != "-1")
		{

			btnSearch.disabled = false;
		}
		else
		{

			btnSearch.disabled = false;
		}
	}
}

function performSearch()
{
	var selectBrand = document.getElementById("selectBrand");
	var selectModel = document.getElementById("selectModel");
	//*var selectJoe = document.getElementById("selectJoe");

	
	if (selectModel != null)
	{
		//*var mod = selectJoe.options[selectJoe.selectedIndex].text;
var Brand = selectBrand.options[selectBrand.selectedIndex].text.replace(' ', '_' ).split(' ').join('_');

var Model = selectModel.options[selectModel.selectedIndex].text.replace(' ', '_' ).split(' ').join('_');
      
		var url = "https://usaweld.com/collections/";
	
        url += Brand + "_" + Model;

		doSearch(url); 		
	}
}

function doSearch(url)
{
		top.location.href = url; 
}// JavaScript Document// JavaScript Document